import { cva } from '@/styled-system/css';

export const paginationPageButtonRecipe = cva({
  base: {
    position: 'relative',
    display: 'inline-flex',
    flexGrow: 0,
    alignItems: 'center',
    justifyContent: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease, color 200ms ease',
    },
    width: 'action.md',
    height: 'action.md',
    backgroundColor: { base: 'bg.invisible' },
    borderRadius: 'shape.ellipse',
    boxShadowColor: { base: 'transparent.invisible' },
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.thick} var(--shadow-color), {shadows.focus}',
    },
    color: {
      base: 'text.neutral',
    },
    textStyle: 'body-bold',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
    selected: {
      true: {
        opacity: 1,
        color: { base: 'text.neutral' },
        backgroundColor: { base: 'bg.action.soft.selected.default' },
        boxShadowColor: { base: 'border.action.hero.selected.default' },
      },
      false: {
        cursor: 'pointer',
        color: {
          _hover: 'text.neutral-fixed',
          _active: 'text.neutral-fixed',
        },
        backgroundColor: {
          _hover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        boxShadowColor: {
          _active: 'transparent.invisible',
        },
      },
    },
  },
});
